/**
 * The whole app renders at `--app-zoom` (0.8 on desktop, see styles/global.css) via `html { zoom }`.
 *
 * Under CSS zoom, getBoundingClientRect(), window.innerWidth/innerHeight and window.scrollY are in
 * screen px, but px written into `style` are page px (the browser multiplies them by the zoom).
 * So any JS that places an element from screen measurements must divide by the zoom first.
 */
export const getPageZoom = () => {
  if (typeof window === 'undefined') return 1;
  return parseFloat(getComputedStyle(document.documentElement).zoom) || 1;
};

/** Screen px → page px. */
export const toPage = (px) => px / getPageZoom();

/**
 * Converts every number in a position object ({ top, left, width, … }) from screen px to page px.
 * null/undefined/strings pass through untouched.
 */
export const toPagePx = (pos) => {
  const z = getPageZoom();
  if (z === 1) return pos;
  return Object.fromEntries(
    Object.entries(pos).map(([k, v]) => [k, typeof v === 'number' ? v / z : v])
  );
};
